import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import { addCurrency, getCurrencyById, updateCurrency } from "../../../services/CurrencyService";
import { Button } from "react-bootstrap";

const AddCurrency = () => {
  const [loading, setLoading] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [currencyValue, setCurrencyValue] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchDUration = async () => {
        try {
          setLoading(true);
          const response = await getCurrencyById(id);
          const currency = response?.data;
          setCurrencyValue(currency?.data?.currency_value);
          setCurrencySymbol(currency?.data?.currency_symbol);
        } catch (err) {
          console.error("Error fetching currency:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchDUration();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!currencySymbol.trim()) {
      newErrors.currencySymbol = "Currency Symbol is required";
    }

    if (!currencyValue.trim()) {
      newErrors.currencyValue = "Currency Value is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const currencyData = { currency_value: currencyValue, currency_symbol: currencySymbol };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING COUNTRY ---
        await updateCurrency(id, currencyData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Currency details updated successfully",
        });
        navigate("/currency");
      } else {
        // --- CREATE NEW COUNTRY ---
        const response = await addCurrency(currencyData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Currency added successfully",
          });
          navigate("/currency");
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Currency" : "Add Currency"}`}
        motherMenu="Currency"
        activeMenuLink={`${id ? `edit-currency/${id}` : "add-currency"}`}
        motherMenuLink={"currency"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/currency");
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Currency List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Currency Symbol</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Currency Symbol"
                        value={currencySymbol} // bind value
                        onChange={(e) => setCurrencySymbol(e.target.value)} // update state
                      />
                      {errors?.currencySymbol && (
                        <div className="text-danger mb-3 mt-1">
                          {errors.currencySymbol}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Currency Value</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Currency Value"
                        value={currencyValue} // bind value
                        onChange={(e) => setCurrencyValue(e.target.value)} // update state
                      />
                      {errors?.currencyValue && (
                        <div className="text-danger mb-3 mt-1">
                          {errors.currencyValue}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigate("/currency")}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCurrency;
